import type { Epic } from 'Flux/index.js'
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators'
import { filter, of } from 'rxjs'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { addMessage } from 'Flux/Slice/Application/ApplicationSlice.js'
import { errorMessage } from 'Model/Message/IMessage.js'
import { explainProcessingTypeRefusal } from 'Util/sequencingPlatform.js'
import { describeOrderWriteRefusal, isOrderVersionConflict, ORDER_VERSION_CONFLICT_MESSAGE } from '../orderWriteRefusal.js'

export const UpdateOrderNameEpic: Epic = (action$, state$, { OrderRepository, [orderSlice.name]: order }) =>
  action$.pipe(
    filter(order.updateOrderNameRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const current = state.order.order
      return OrderRepository.updateOrderName(action.payload).pipe(
        // Reload datasets too: switching the sample configuration flips the samples' isTrimmed flag server-side.
        mergeMap((response) => of(order.updateOrderNameSuccess(response), order.getAllDatasetRequest({ orderId: action.payload.orderId }))),
        catchError((error) =>
          of(
            order.updateOrderNameFailure({ error }),
            addMessage(
              errorMessage(
                (isOrderVersionConflict(error) && ORDER_VERSION_CONFLICT_MESSAGE) ||
                  describeOrderWriteRefusal(error) ||
                  (current && current !== 'LOADING' && explainProcessingTypeRefusal(current, action.payload.processingType)) ||
                  'Saving the order failed.'
              )
            )
          )
        )
      )
    })
  )
